export default "__VITE_ASSET__CpmRFAw$__";